// extracted by mini-css-extract-plugin
export var root = "r_1";
export var grid = "r_bs";
export var logo = "r_R";
export var heading = "r_w";
export var asterisk = "r_bt";
export var desc = "r_x";